import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";

export interface LevelTwoAppCardProps {
  id: string;
  iconStatic: string;
  iconHover: string;
  title: React.JSX.Element;
  alt: string;
  onClick: () => void;
}

export function LevelTwoAppCard({
  id,
  iconStatic,
  iconHover,
  title,
  alt,
  onClick,
}: LevelTwoAppCardProps) {
  const [isHovering, setIsHovering] = useState<boolean>(false);
  return (
    <Button
      id={id}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "0 auto",
        height: "100%",
        backgroundColor: "transparent",
      }}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onClick={onClick}
    >
      <Box
        sx={{
          "width": 270,
          "display": "flex",
          "alignItems": "flex-start",
          "& svg": { width: "100%", height: "100%" },
        }}
      >
        <img
          style={{ width: "100%" }}
          src={isHovering ? iconHover : iconStatic}
          alt={alt}
        />
      </Box>
      <Typography
        sx={{
          fontSize: "1.125rem",
          fontFamily: "Source Sans Pro, sans-serif",
          fontWeight: "bold",
          marginTop: "auto",
          color: (theme) => theme.palette.primary.main,
        }}
      >
        {title}
      </Typography>
    </Button>
  );
}
